// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderInfo":"c-o_fQ"};